export function WidgetShell({ children }: { children: React.ReactNode }) {
  return <div className="w-full">{children}</div>;
}
